import { IconName } from '@/config/icons'
import { UserRole } from '@prisma/client'

export interface UserMenuItem {
  label: string
  href: string
  icon: IconName
}

export function getUserMenuItems(role?: UserRole): UserMenuItem[] {
  switch (role) {
    case UserRole.ADMIN:
      return [
        { label: 'Dashboard', href: '/dashboard', icon: 'dashboard' },
      ]
    case UserRole.INSTALLER:
      return [
        { label: 'My Schedule', href: '/installer', icon: 'calendar' },
      ]
    case UserRole.USER:
    default:
      return [
        { label: 'My Account', href: '/account', icon: 'user' },
      ]
  }
}
